import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes, { func, string } from 'prop-types';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Accordion from 'react-bootstrap/Accordion';
import AccordionToggle from 'react-bootstrap/AccordionToggle';
import AccordionCollapse from 'react-bootstrap/AccordionCollapse';
import { FiFolder, FiArchive, FiChevronDown } from 'react-icons/fi';
import { FaCaretRight } from 'react-icons/fa';
import { MdPermContactCalendar } from 'react-icons/md';
import { receivedDocsFolderSelector } from './slice';

export const ReceivedFromReferralsDocsLabel = (
  <div className={'d-flex flex-row justify-content-between'}>
    <span>
      <FiFolder size={'1.3em'} className={'mr-2'} /> Received From Referrals
    </span>
    <FiChevronDown size={'1.3em'} />
  </div>
);

export const ArchivedDocsLabel = (
  <div className={'d-flex flex-row justify-content-between'}>
    <span>
      <FiArchive size={'1.3em'} className={'mr-2'} /> Archived
    </span>
    <FiChevronDown size={'1.3em'} />
  </div>
);

export const SentToReferralsDocsLabel = (
  <div>
    <FiFolder size={'1.3em'} className={'mr-2'} /> Sent To Referrals
  </div>
);

export const ExternalContactLabel = (
  <div className={'d-flex align-items-center'}>
    <MdPermContactCalendar size={'1.3em'} className={'mr-2'} /> Contacts
  </div>
);

function SecureShareLeftPanel({ handleOnClick, activeFolderId, activePanelType }) {
  const docFolders = useSelector(receivedDocsFolderSelector);

  const receivedFolders = docFolders.filter(({ receivedCount }) => receivedCount);
  const archivedFolders = docFolders.filter(({ archivedCount }) => archivedCount);

  useEffect(() => {
    const defaultFolder = receivedFolders.find(({ receivedCount }) => receivedCount);
    handleOnClick('unarchived', defaultFolder?.id);
  }, [docFolders.length]);

  return (
    <Container fluid>
      <Row>
        <Col sm={12}>
          <Accordion defaultActiveKey="0" className="mb-2">
            <AccordionToggle as={'div'} className={`py-3 px-2 border-0 bg-white ${receivedFolders.length > 0 ? 'csr-pointer' : ''}`} eventKey="0">
              <div className={`d-flex flex-row justify-content-between ${receivedFolders.length === 0 ? 'text-muted' : ''}`}>
                <span>
                  <FiFolder size={'1.3em'} className={'mr-2'} /> Received From Referrals
                </span>
                <FiChevronDown size={'1.3em'} />
              </div>
            </AccordionToggle>
            <AccordionCollapse eventKey="0">
              <div>
                {receivedFolders.map((fol) => {
                  const { firstName, lastName, id, unreadCount } = fol;
                  return (
                    <div
                      onClick={() => handleOnClick('unarchived', id)}
                      className={`p-3 border-0  csr-pointer d-flex flex-row justify-content-between ${activeFolderId === id && activePanelType === 'unarchived' ? 'bg-active' : ''}`}
                      key={`unarchived-${id}`}
                    >
                      <span>
                        <FaCaretRight className="mr-3" />
                        {`${firstName} ${lastName}`}
                      </span>
                      <span>{unreadCount || ''}</span>
                    </div>
                  );
                })}
              </div>
            </AccordionCollapse>
          </Accordion>
          <Accordion defaultActiveKey="1" className="my-2">
            <AccordionToggle as={'div'} className={`py-3 px-2 border-0 bg-white ${archivedFolders.length > 0 ? 'csr-pointer' : ''}`} eventKey="1">
              <div className={`d-flex flex-row justify-content-between ${archivedFolders.length === 0 ? 'text-muted' : ''}`}>
                <span>
                  <FiArchive size={'1.3em'} className={'mr-2'} /> Archived
                </span>
                <FiChevronDown size={'1.3em'} />
              </div>
            </AccordionToggle>
            <AccordionCollapse eventKey="1">
              <div>
                {archivedFolders.map((fol) => {
                  const { firstName, lastName, id } = fol;
                  return (
                    <div
                      onClick={() => handleOnClick('archived', id)}
                      className={`p-3 border-0 csr-pointer ${activeFolderId === id && activePanelType === 'archived' ? 'bg-active' : ''}`}
                      key={`archived-${id}`}
                    >
                      <FaCaretRight className="mr-3" />
                      {`${firstName} ${lastName}`}
                    </div>
                  );
                })}
              </div>
            </AccordionCollapse>
          </Accordion>
          <div onClick={() => handleOnClick('sentDocs', null)} className={`py-3 px-2 my-2 border-0 csr-pointer ${activePanelType === 'sentDocs' ? 'bg-active' : ''}`}>
            {SentToReferralsDocsLabel}
          </div>
          <div
            onClick={() => {
              handleOnClick('contacts', null);
            }}
            className={`py-3 px-2 my-2 border-0  csr-pointer ${activePanelType === 'contacts' ? 'bg-active' : ''}`}
          >
            {ExternalContactLabel}
          </div>
        </Col>
      </Row>
    </Container>
  );
}

SecureShareLeftPanel.propTypes = {
  handleOnClick: func,
  activeFolderId: string,
  activePanelType: string,
};
SecureShareLeftPanel.defaultProps = {};

export default SecureShareLeftPanel;
